import type { Attachment } from '@missionlabs/smartagent-service-thread'
import classNames from 'classnames'
import { ReactPortal } from 'components'
import AttachmentList from '../../components/AttachmentList'
import AttachmentsLoader from '../AttachmentsLoader'
import styles from './AttachmentsList.module.scss'

interface Props {
    attachments: Attachment[]
    isAttachmentLoading: boolean
    containerElement: Element | null
    isEditorRedesigned?: boolean
    onRemove: (value: number, fileName: string) => void
}

const AttachmentsList = ({
    containerElement,
    attachments,
    isAttachmentLoading,
    isEditorRedesigned,
    onRemove,
}: Props) => {
    const wrapperClassNames = classNames(styles.attachmentsWrapper, {
        [styles.lexicalEditor]: isEditorRedesigned,
    })

    return (
        <ReactPortal containerElement={containerElement}>
            <div className={wrapperClassNames}>
                <AttachmentsLoader showLoader={isAttachmentLoading} key="attachments-loader" />
                <AttachmentList
                    attachments={attachments}
                    isEditorRedesigned={isEditorRedesigned}
                    onRemove={onRemove}
                />
            </div>
        </ReactPortal>
    )
}

export default AttachmentsList
